(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[86],{

/***/ 58797:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[...slug]",
      function () {
        return __webpack_require__(42394);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./context/categories.tsx
var categories = __webpack_require__(18650);
// EXTERNAL MODULE: ./components/site/seo.tsx
var seo = __webpack_require__(51289);
// EXTERNAL MODULE: ./components/markdown/index.tsx + 11 modules
var markdown = __webpack_require__(64557);
// EXTERNAL MODULE: ./components/site/docsLayout.tsx
var docsLayout = __webpack_require__(48257);
// EXTERNAL MODULE: ./components/site/documentationContent.tsx + 2 modules
var documentationContent = __webpack_require__(55721);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/@sparkpost/matchbox/dist/matchbox.esm.js + 50 modules
var matchbox_esm = __webpack_require__(18518);
// EXTERNAL MODULE: ./node_modules/@sparkpost/matchbox-icons/dist/matchbox-icons.esm.js
var matchbox_icons_esm = __webpack_require__(6848);
// EXTERNAL MODULE: ./utils/string.ts
var string = __webpack_require__(14045);
;// CONCATENATED MODULE: ./components/site/docsIndexListPageContent.tsx






var DocsIndexListPageContent = function(props) {
    var postsPerClick = 7;
    var ref = (0,react.useState)(postsPerClick), paginationCount = ref[0], setPaginationCount = ref[1];
    var navigationData = props.navigationData;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            navigationData && navigationData.items ? navigationData.items.slice(0, paginationCount).map(function(item, i) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
                            px: "500",
                            py: "650",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                    as: "h3",
                                    children: item.title
                                }),
                                item.lastUpdated && /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                    pt: "200",
                                    pb: "400",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Tag */.Vp, {
                                        children: (0,string/* formatDate */.p6)(item.lastUpdated)
                                    })
                                }),
                                item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                    as: "p",
                                    maxWidth: "1150",
                                    children: item.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                    pt: "400",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: item.link,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Button */.zx, {
                                            variant: "outline",
                                            color: "blue",
                                            children: "Read More"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                    ]
                }, "navDataItem".concat(i)));
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "Whoops! This section is empty."
            }),
            navigationData && navigationData.items && paginationCount < navigationData.items.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                textAlign: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Button */.zx, {
                    variant: "outline",
                    color: "blue",
                    onClick: function() {
                        return setPaginationCount(paginationCount + postsPerClick);
                    },
                    children: [
                        "Show More ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_icons_esm/* KeyboardArrowDown */.WdC, {})
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var docsIndexListPageContent = (DocsIndexListPageContent);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./pages/docs/[...slug].tsx








var PostPage = function(props) {
    var content = props.content, data = props.data, navigationData = props.navigationData, isIndex = props.isIndex, categoryData = props.categoryData;
    var router = (0,next_router.useRouter)();
    // This is to check for a url that either contains a trailing slash or not (since netlify will show either)
    var trailingSlashOrNo = function(navData) {
        var linkComponents = navData.link.split('/');
        linkComponents.pop();
        var link = linkComponents.join('/');
        return link === router.asPath || link + '/' === router.asPath;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(categories/* CategoriesProvider */.z, {
        data: categoryData,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: data.title,
                description: data.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(docsLayout/* default */.Z, {
                navigationData: navigationData,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(documentationContent/* default */.Z, {
                    title: data.title,
                    lastUpdated: data.lastUpdated,
                    isIndex: isIndex,
                    description: data.description,
                    children: isIndex && navigationData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(docsIndexListPageContent, {
                        navigationData: navigationData.find(trailingSlashOrNo)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(markdown/* default */.Z, {
                        children: content
                    })
                })
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (PostPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [398,267,371,257,767,774,888,179], function() { return __webpack_exec__(58797); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);